import { doc, getDoc, updateDoc, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { createNotification } from "./notificationUtils";

export const checkAndAssignBadges = async (userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return;

    const userData = userSnap.data();
    const currentBadges = userData.badges || [];
    const currentStreakBadges = userData.streakBadges || [];
    const newBadges = [...currentBadges];
    const newStreakBadges = [...currentStreakBadges];
    let xpToAdd = 0;

    // Mevcut rozet kontrolleri
    const goalsSnap = await getDocs(query(collection(db, "goals"), where("userId", "==", userId), where("completed", "==", true)));
    const completedGoalsCount = goalsSnap.docs.length;
    if (completedGoalsCount >= 10 && !currentBadges.includes("hedef_ustası")) {
      newBadges.push("hedef_ustası");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Hedef Ustası" });
    }

    const commentsSnap = await getDocs(query(collection(db, "comments"), where("userId", "==", userId)));
    const commentCount = commentsSnap.docs.length;
    if (commentCount >= 10 && !currentBadges.includes("yorumcu")) {
      newBadges.push("yorumcu");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Yorumcu" });
    }

    const postsSnap = await getDocs(query(collection(db, "posts"), where("userId", "==", userId)));
    const postCount = postsSnap.docs.length;
    if (postCount >= 5 && !currentBadges.includes("aktif_uye")) {
      newBadges.push("aktif_uye");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Aktif Üye" });
    }

    const popularPostSnap = await getDocs(query(collection(db, "posts"), where("userId", "==", userId), where("likes", ">=", 10)));
    if (!popularPostSnap.empty && !currentBadges.includes("popüler_post")) {
      newBadges.push("popüler_post");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Popüler Post" });
    }

    const studyTimeSnap = await getDocs(query(collection(db, "studyTimes"), where("userId", "==", userId)));
    const totalStudyHours = studyTimeSnap.docs.reduce((total, doc) => total + (doc.data().hours || 0), 0);
    if (totalStudyHours >= 50 && !currentBadges.includes("çalışkan_saatçi")) {
      newBadges.push("çalışkan_saatçi");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Çalışkan Saatçi" });
    }

    const morningStudySnap = await getDocs(query(collection(db, "studyTimes"), where("userId", "==", userId)));
    let morningStreak = 0;
    let lastMorningDate = null;
    for (const doc of morningStudySnap.docs.sort((a, b) => a.data().date.toDate() - b.data().date.toDate())) {
      const studyData = doc.data();
      const studyDate = studyData.date.toDate();
      const studyHour = studyDate.getHours();
      if (studyHour >= 6 && studyHour < 8) {
        if (lastMorningDate && (studyDate - lastMorningDate) / (1000 * 60 * 60 * 24) === 1) {
          morningStreak++;
        } else {
          morningStreak = 1;
        }
        lastMorningDate = studyDate;
      }
    }
    if (morningStreak >= 5 && !currentBadges.includes("erken_kalkan")) {
      newBadges.push("erken_kalkan");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Erken Kalkan" });
    }

    let nightStreak = 0;
    let lastNightDate = null;
    for (const doc of morningStudySnap.docs.sort((a, b) => a.data().date.toDate() - b.data().date.toDate())) {
      const studyData = doc.data();
      const studyDate = studyData.date.toDate();
      const studyHour = studyDate.getHours();
      if (studyHour >= 22 || studyHour < 2) {
        if (lastNightDate && (studyDate - lastNightDate) / (1000 * 60 * 60 * 24) === 1) {
          nightStreak++;
        } else {
          nightStreak = 1;
        }
        lastNightDate = studyDate;
      }
    }
    if (nightStreak >= 5 && !currentBadges.includes("gece_kuşu")) {
      newBadges.push("gece_kuşu");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Gece Kuşu" });
    }

    const followingSnap = await getDocs(query(collection(db, "follows"), where("followerId", "==", userId)));
    const followingCount = followingSnap.docs.length;
    if (followingCount >= 10 && !currentBadges.includes("sosyal_birey")) {
      newBadges.push("sosyal_birey");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Sosyal Birey" });
    }

    const motivatingPostsSnap = await getDocs(query(collection(db, "posts"), where("userId", "==", userId), where("likes", ">=", 5)));
    const motivatingPostCount = motivatingPostsSnap.docs.length;
    if (motivatingPostCount >= 5 && !currentBadges.includes("motivasyon_kaynağı")) {
      newBadges.push("motivasyon_kaynağı");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Motivasyon Kaynağı" });
    }

    const lessonsSnap = await getDocs(query(collection(db, "lessons"), where("userId", "==", userId), where("completed", "==", true)));
    const lessonCount = lessonsSnap.docs.length;
    if (lessonCount >= 10 && !currentBadges.includes("ders_kaptanı")) {
      newBadges.push("ders_kaptanı");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Ders Kaptanı" });
    }

    const trialsSnap = await getDocs(query(collection(db, "trials"), where("userId", "==", userId)));
    const trialCount = trialsSnap.docs.length;
    if (trialCount >= 10 && !currentBadges.includes("deneme_fatihi")) {
      newBadges.push("deneme_fatihi");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Deneme Fatihi" });
    }

    const tasksSnap = await getDocs(query(collection(db, "dailyTasks"), where("userId", "==", userId), where("completed", "==", true)));
    const taskCount = tasksSnap.docs.length;
    if (taskCount >= 20 && !currentBadges.includes("görev_avcısı")) {
      newBadges.push("görev_avcısı");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Görev Avcısı" });
    }

    const userLevel = userData.level || 1;
    if (userLevel >= 5 && !currentBadges.includes("seviye_atlayan")) {
      newBadges.push("seviye_atlayan");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Seviye Atlayan" });
    }

    // Streak rozetleri
    const streaksSnap = await getDoc(doc(db, "streaks", userId));
    const streakDays = streaksSnap.exists() ? streaksSnap.data().currentStreak || 0 : 0;
    if (streakDays >= 60 && !currentStreakBadges.includes("streak_myth")) {
      newStreakBadges.push("streak_myth");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Streak Miti" });
    }
    if (streakDays >= 30 && !currentStreakBadges.includes("streak_legend")) {
      newStreakBadges.push("streak_legend");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Streak Efsanesi" });
    }
    if (streakDays >= 15 && !currentStreakBadges.includes("streak_warrior")) {
      newStreakBadges.push("streak_warrior");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Streak Savaşçısı" });
    }
    if (streakDays >= 7 && !currentStreakBadges.includes("streak_star")) {
      newStreakBadges.push("streak_star");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Streak Yıldızı" });
    }
    if (streakDays >= 3 && !currentStreakBadges.includes("streak_beginner")) {
      newStreakBadges.push("streak_beginner");
      xpToAdd += 30;
      await createNotification({ userId, type: "badge", badgeName: "Streak Başlangıcı" });
    }

    // Lig rozetleri (haftalık/aylık şampiyon)
    const weeklyLeaderboard = await getDocs(query(collection(db, "leaderboards/weekly"), where("userId", "==", userId), where("rank", "==", 1)));
    if (!weeklyLeaderboard.empty && !currentStreakBadges.includes("weekly_champion")) {
      newStreakBadges.push("weekly_champion");
      xpToAdd += 50;
      await createNotification({ userId, type: "badge", badgeName: "Haftanın Şampiyonu" });
    }
    const monthlyLeaderboard = await getDocs(query(collection(db, "leaderboards/monthly"), where("userId", "==", userId), where("rank", "==", 1)));
    if (!monthlyLeaderboard.empty && !currentStreakBadges.includes("monthly_legend")) {
      newStreakBadges.push("monthly_legend");
      xpToAdd += 100;
      await createNotification({ userId, type: "badge", badgeName: "Ayın Efsanesi" });
    }

    // Rozetleri ve XP’yi güncelle
    if (newBadges.length !== currentBadges.length || newStreakBadges.length !== currentStreakBadges.length || xpToAdd > 0) {
      const newLevel = Math.floor(((userData.xp || 0) + xpToAdd) / 100) + 1;
      await updateDoc(userRef, {
        badges: newBadges,
        streakBadges: newStreakBadges,
        xp: (userData.xp || 0) + xpToAdd,
        level: newLevel,
      });
    }
  } catch (err) {
    console.error("❌ Rozet kontrolü başarısız:", err);
  }
};